module.exports = __webpack_public_path__ + "static/media/pencil.d0a83d4f.svg";